import { EnvironmentConfig } from './types';

export const developmentConfig: EnvironmentConfig = {
  // Environment identification
  environment: 'development',
  
  // API Configuration - Development (using AWS API Gateway)
  // Replace with your actual API Gateway URL from: aws cloudformation describe-stacks --stack-name StreamingPlatformStack-dev --query 'Stacks[0].Outputs[?OutputKey==`APIGatewayURL`].OutputValue' --output text
  apiBaseUrl: 'https://your-api-gateway-id.execute-api.us-west-2.amazonaws.com/dev',
  apiTimeout: 10000,
  
  // Authentication Configuration (Development Cognito Pool)
  cognitoUserPoolId: 'us-east-1_dev123456',
  cognitoUserPoolClientId: 'dev-client-id-123456',
  cognitoHostedUiUrl: 'https://dev-streaming-platform.auth.us-east-1.amazoncognito.com',
  cognitoRegion: 'us-east-1',
  
  // CDN and Asset Configuration - Development CDN
  // Replace with your actual CloudFront distribution domain from CloudFormation outputs
  imagesCdnUrl: 'https://your-cloudfront-domain.cloudfront.net',
  staticAssetsCdnUrl: 'http://localhost:3000',
  
  // Feature Flags - Development optimized
  enableDebugMode: true,
  enableAnalytics: false,
  enablePerformanceMonitoring: true,
  enableErrorReporting: false,
  
  // Development Tools - Enabled for development
  enableDevTools: true,
  enableHotReload: true,
  
  // Security Configuration - Relaxed for development
  enableCSP: false,
  allowedOrigins: ['http://localhost:3000', 'https://api.streaming-platform.com'],
  
  // Performance Configuration - Development optimized
  enableServiceWorker: false,
  enableLazyLoading: false,
  maxRetries: 2,
  retryDelay: 1000,
};